export default "/images/49cdbe53970daf7db8d1b1c63ee5777c.avif";